import { createFileRoute } from '@tanstack/react-router';
import { DefaultRecordDetail } from '../../../features/overdue/components/DefaultRecordDetail';
import { usePageTitle } from '../../../lib/hooks.js';

export const Route = createFileRoute('/_auth/defaults/$id')({
  component: DefaultRecordDetailPage,
});

function DefaultRecordDetailPage() {
  usePageTitle('Default Record Details');
  const { id } = Route.useParams();

  return <DefaultRecordDetail recordId={id} />;
}
